<template>
  <section class="pact-promise-section">
    <div class="row mx-0">
      <div class="col-12 px-0">
        <h5 class="pact-promise-title">
          Pact Promise
        </h5>
        <div class="pact-promise-message">
          <div class="pact-promise-icon">
            <img
              src="/assets/icons/secondary/trust-signifiers/pact-promise.svg"
              alt="Pact Promise"
            >
          </div>
          <p class="pact-promise-text">
            If you don't love your first coffee we'll replace it free of charge - That's our Pact
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PactPromise',
}
</script>

<style lang="scss" scoped>
@use '../../../../assets/sass/inc/default/grid/grid-vue-mixins.scss' as *;

.pact-promise-section {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
  border-top: 3px solid #F4F4F4;

  @media(min-width: 400px){
    padding-left: 30px;
    padding-right: 30px;
  }

  // &::before{
  //   content: '';
  //   height: 20px;
  //   width: 100%;
  //   position: absolute;
  //   top: -23px;
  //   left: 0px;
  //   background-color: #F9F9F9;
  // }

  .pact-promise-content {
    background: #fff;
  }

  .pact-promise-title {
    color: #212427;
    font-family: 'Apercu';
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    margin-bottom: 15px;

    @media (min-width: 992px) {
      font-size: 26px;
      line-height: 32px;
    }
  }

  .pact-promise-message {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .pact-promise-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #1D4045;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
      filter: brightness(0) invert(1);
    }
  }

  .pact-promise-text {
    color: #212427;
    font-family: 'Apercu-medium';
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 0;
  }
}
</style>
